var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelPlaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 9.9375C26.25 7.76625 21.21 6 15 6C8.79 6 3.75 7.76625 3.75 9.9375C3.75 11.9738 8.19375 13.6612 13.875 13.8525V18.375H12.0188C11.0963 18.375 10.275 18.9375 9.92625 19.7925L8.25 24H10.5L11.85 20.625H18.15L19.5 24H21.75L20.0625 19.7925C19.725 18.9375 18.8925 18.375 17.9812 18.375H16.125V13.8525C21.8062 13.6612 26.25 11.9738 26.25 9.9375ZM15 8.25C19.5563 8.25 22.5825 9.2175 23.685 9.9375C22.5825 10.6575 19.5563 11.625 15 11.625C10.4437 11.625 7.4175 10.6575 6.315 9.9375C7.4175 9.2175 10.4437 8.25 15 8.25Z",
    fill: "#004B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelPlaces);
export default __webpack_public_path__ + "static/media/panel-places.f0a8d3f128c2b70981fc47df865d8577.svg";
export { ForwardRef as ReactComponent };